/**
 * Runtime configuration. Values are injected at build time via Vite env vars
 * (VITE_*), which the CI/CD deploy sets per environment from Terraform outputs.
 */
export interface AppConfig {
  apiEndpoint: string;
  userPoolId: string;
  userPoolClientId: string;
  region: string;
  env: string;
}

export const config: AppConfig = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT ?? '',
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  region: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
  env: import.meta.env.VITE_APP_ENV ?? 'dev',
};
